const styles = {
  inputContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "12px",
  },
  label: {
    flex: 1,
    color: "#8C8C8C",
    fontSize: "16px",
    width: "40%",
  },
  action: {
    width: "60%",
  },
};

export default styles;
